import { Suspense } from "react";
import { lazyWithRetry } from "@circle-react/helpers/lazyRetry";
import { PageLoader } from "@circle-react/pages/PageLoader";

const BrandedAppsBuilderLandingPageComponent = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "BrandedAppsBuilderLandingPage" */ "@circle-react/components/SettingsApp/Plan/PlusPlan/BrandedAppsBuilderLandingPage"
    ),
);

export const BrandedAppsBuilderLandingPage = () => (
  <Suspense fallback={<PageLoader />}>
    <BrandedAppsBuilderLandingPageComponent />
  </Suspense>
);
